import { render, staticRenderFns } from "./adTip.vue?vue&type=template&id=2a05fbaf&scoped=true&"
import script from "./adTip.vue?vue&type=script&lang=js&"
export * from "./adTip.vue?vue&type=script&lang=js&"
import style0 from "./adTip.vue?vue&type=style&index=0&id=2a05fbaf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a05fbaf",
  null
  
)

export default component.exports